import { ReactNode } from "react";
import { Stack, Container, SxProps } from "@mui/material";
type Props = {
  children: ReactNode;
  layoutStyles?: SxProps;
  containerStyles?: SxProps;
};

// The old xs:"5rem ..." top padding compensated for a mobile-only AppBar
// overlapping content. TopBar is now persistent and MainLayout already
// reserves its height for every breakpoint, so this only needs normal
// page padding.
const PageLayout = ({
  children,
  layoutStyles = {},
  containerStyles = {},
}: Props) => {
  return (
    <Stack
      sx={{
        width: "100%",
        minHeight: "100%",
        padding: { xs: "1rem", md: "1.5rem" },
        ...layoutStyles,
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          ...containerStyles,
        }}
      >
        {children}
      </Container>
    </Stack>
  );
};

export default PageLayout;
